import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const acquisition: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'adType' },
            { type: 'field', field: 'adCash' },
            { type: 'field', field: 'adShares' },
            { type: 'field', field: 'adFlag' },
            { type: 'field', field: 'adDateFlag' },
            { type: 'field', field: 'adUnsolicited' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'adStat' },
            { type: 'field', field: 'adCurrency' },
            { type: 'field', field: 'adAcquirerTicker' },
            { type: 'field', field: 'adTargetTicker' },
            { type: 'field', field: 'adPctOwned' },
            { type: 'field', field: 'adPctSought' },
        ],
    },
];

export default acquisition;
